<template>
  <Dialog
    :visible="paymentStore.dialog.visible"
    width="680px"
    top="0"
    :padding="0"
    :abled-close="true"
    :is-align-center="true"
    :is-justify-center="true"
    bgclor="rgba(4, 8, 18, 0.82)"
    z-index="3000"
    @dialog:visible="handleClose"
  >
    <div class="payment-switch-shell">
      <div class="payment-switch-title">提示</div>
      <div class="payment-switch-message">
        <p>本次操作{{ insufficientLabel }}余额不足，是否</p>
        <p>切换为{{ switchToLabel }}支付？</p>
      </div>

      <label class="payment-switch-checkbox">
        <input
          type="checkbox"
          :checked="paymentStore.dialog.applyGlobally"
          @change="handleToggleGlobal"
        />
        <span>同时将全局支付切换为</span>
        <span class="payment-switch-highlight">{{ switchToLabel }}</span>
        <span>支付</span>
      </label>

      <div class="payment-switch-actions">
        <button type="button" class="btn btn-cancel" @click="handleClose(false)">取消</button>
        <button type="button" class="btn btn-confirm" @click="handleConfirm">确定</button>
      </div>
    </div>
  </Dialog>
</template>

<script setup lang="ts">
import Dialog from "@/components/dialog.vue";
import usePaymentStore from "@/stores/payment";
import useHomeStore from "@/stores/home";

const paymentStore = usePaymentStore();
const homeStore = useHomeStore();

const insufficientLabel = computed(() =>
  paymentStore.dialog.insufficientMethod === "bean" ? "智媒豆" : "智媒币"
);

const switchToLabel = computed(() =>
  paymentStore.dialog.switchToMethod === "bean" ? "智媒豆" : "智媒币"
);

const handleToggleGlobal = (event: Event) => {
  const target = event.target as HTMLInputElement;
  paymentStore.setApplyGlobally(target.checked);
};

const handleClose = (visible = false) => {
  if (visible) return;
  paymentStore.cancelDialog();
};

const handleConfirm = async () => {
  const nextMethod = paymentStore.dialog.switchToMethod;

  paymentStore.closeDialog();

  try {
    if (paymentStore.dialog.applyGlobally) {
      await homeStore.updatePowerType(nextMethod === "bean" ? 1 : 2);
    } else {
      paymentStore.setPaymentMethod(nextMethod);
    }

    if (paymentStore.confirmHandler) {
      await paymentStore.confirmHandler(nextMethod);
    }
  } catch (error) {
    console.error(error);
  } finally {
    paymentStore.clearPendingAction();
  }
};
</script>

<style scoped lang="scss">
.payment-switch-shell {
  min-height: 400px;
  padding: 34px 40px 32px;
  color: #ffffff;
  background:
    linear-gradient(180deg, rgba(19, 24, 41, 0.96) 0%, rgba(10, 14, 27, 0.98) 100%),
    radial-gradient(circle at top, rgba(63, 114, 255, 0.2) 0%, rgba(63, 114, 255, 0) 48%);
}

.payment-switch-title {
  font-size: 24px;
  font-weight: 700;
  line-height: 1.2;
}

.payment-switch-message {
  margin: 36px auto;
  max-width: 420px;
  text-align: center;
  font-size: 20px;
  line-height: 2;
  font-weight: 600;
}

.payment-switch-checkbox {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  font-size: 16px;
  color: rgba(255, 255, 255, 0.88);
  user-select: none;

  input {
    width: 24px;
    height: 24px;
    margin: 0 4px 0 0;
    accent-color: #2c72ff;
    cursor: pointer;
  }
}

.payment-switch-highlight {
  color: #2cd7ff;
}

.payment-switch-actions {
  margin-top: 56px;
  display: flex;
  justify-content: center;
  gap: 20px;
}

.btn {
  width: 126px;
  height: 44px;
  border-radius: 28px;
  font-size: 18px;
  font-weight: 700;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;

  &:hover {
    transform: translateY(-1px);
  }
}

.btn-cancel {
  color: rgba(255, 255, 255, 0.92);
  border: 1px solid rgba(111, 128, 175, 0.35);
  background: rgba(10, 17, 34, 0.75);
}

.btn-confirm {
  color: #ffffff;
  background: linear-gradient(135deg, #0028FF 0%, #2800FF 53%, #00C3FF 100%);
}

@media (max-width: 768px) {
  .payment-switch-shell {
    min-height: auto;
    padding: 24px 18px 28px;
  }

  .payment-switch-title {
    font-size: 20px;
  }

  .payment-switch-message {
    margin: 40px auto 26px;
    font-size: 17px;
  }

  .payment-switch-checkbox {
    align-items: flex-start;
    justify-content: flex-start;
    flex-wrap: wrap;
    font-size: 14px;

    input {
      width: 20px;
      height: 20px;
      margin-top: 1px;
    }
  }

  .payment-switch-actions {
    margin-top: 36px;
    gap: 12px;
  }

  .btn {
    width: calc(50% - 8px);
    min-width: 120px;
    height: 46px;
    font-size: 16px;
  }
}
</style>
